<template>
    <div v-bind:class="[classstyle , curError ? 'has-error' : '']">
        <main>
            <slot></slot>
            <errorinputcomponent v-if="curError" :errors="curError"></errorinputcomponent>
        </main>
    </div>
</template>

<script>
    export default {
        props: {
            classstyle: { default: function () { return 'form-group'; }},
            errorinput: { default: function() { return null; }},
        },
        data: function(){
            return {
                curError: null
            }
        },
        computed: {
        },
        watch: { 
           errorinput: function (newval,oldValue) {
               this.errorinput = newval;
               this.curError = newval;
           }
        },
        mounted(){
            this.curError = this.errorinput;
            $(this.$el).find('.form-control').bind('change keyup', () => {
                this.curError = null;
                this.$emit('on-error-discard',{})
            });
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    label {font-weight: bold;}
</style>